<template>
  <div class="login-container">
    <div class="login-left">
      <canvas id="systemCanvas" width="911" height="735"></canvas>
      <section>
        <span class="span" v-for="item in 14" :key="item"></span>
      </section>
    </div>
    <div class="login-copyright">
      <img src="../../assets/images/Mask@2x.png" alt="" srcset="" />
      Copyright©深圳市振瀚信息技术有限公司
    </div>
    <div class="login-panel">
      <div class="login-form">
        <div class="login-title">运营管理平台</div>
        <div class="login-title-en">
          <img
            ref="canvas_bg0"
            src="../../assets/images/login-title-left.png"
          />
          <span> Operations Management Platform</span>
          <img
            ref="canvas_bg0"
            src="../../assets/images/login-title-right.png"
          />
        </div>
        <div class="login-component login-user">
          <img src="../../assets/images/login-user1.png" srcset="" />
          <el-input
            v-model.trim="formState.username"
            class="login-input"
            placeholder="账号"
          ></el-input>
        </div>
        <div class="login-component login-password">
          <img src="../../assets/images/login-password1.png" srcset="" />
          <el-input
            v-model.trim="formState.password"
            class="login-input"
            placeholder="密码"
            type="password"
            show-password
          ></el-input>
        </div>
        <div class="login-component login-code">
          <img src="../../assets/images/login-code1.png" srcset="" />
          <el-input
            v-model="formState.verify"
            class="login-input"
            placeholder="验证码"
            maxlength="4"
            @keyup.enter="handleFinish"
          >
            <template v-slot:append>
              <img
                :src="qrCode.base64"
                alt=""
                class="qrCode"
                @click="getCodeUrl"
              />
            </template>
          </el-input>
        </div>
        <div class="login-submit" @click="handleFinish">立即登录</div>
      </div>
    </div>
    <div class="login-waves"></div>
    <div style="display: none">
      <img ref="canvas_bg0" src="../../assets/images/canvas_bg0.png" />
      <img ref="canvas_bg1" src="../../assets/images/canvas_bg1.png" />
    </div>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  ref,
  getCurrentInstance,
  toRefs,
  onMounted
} from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import qs from "qs";

import CryptoJS from "@/utils/crypto.js";
import initWaves from "./particleWave.js";
import { ElMessage } from "element-plus";
export default defineComponent({
  setup() {
    const { proxy } = getCurrentInstance();
    const formRef = ref();
    const state = reactive({
      copyright: window.config.copyright,
      systemName: window.config.systemName ? window.config.systemName : null,
      loginKey: null,
      loginCode: null,
      qrCode: {
        base64: null,
        uuid: null,
        imageByte: []
      },
      canvas: null,
      ctx: null,
      num: 0,
      dotLine: [
        {
          speed: 1,
          step: 0.1,
          currentIndex: 0,
          currentPoint: { x: 360, y: 360 },
          points: [
            { x: 360, y: 360 },
            { x: 275, y: 310 },
            { x: 170, y: 380 },
            { x: 85, y: 330 }
          ]
        },
        {
          speed: 1,
          step: 0.1,
          currentIndex: 0,
          currentPoint: { x: 380, y: 340 },
          points: [
            { x: 380, y: 340 },
            { x: 290, y: 290 },
            { x: 355, y: 250 },
            { x: 280, y: 200 }
          ]
        },
        {
          speed: 1.2,
          step: 0.1,
          currentIndex: 0,
          currentPoint: { x: 420, y: 310 },
          points: [
            { x: 420, y: 310 },
            { x: 360, y: 280 },
            { x: 540, y: 175 },
            { x: 440, y: 110 }
          ]
        },
        {
          speed: 1,
          step: 0.1,
          currentIndex: 0,
          currentPoint: { x: 505, y: 330 },
          points: [
            { x: 505, y: 330 },
            { x: 600, y: 270 },
            { x: 540, y: 240 },
            { x: 600, y: 210 }
          ]
        },
        {
          speed: 1.2,
          step: 0.1,
          currentIndex: 0,
          currentPoint: { x: 530, y: 350 },
          points: [
            { x: 530, y: 350 },
            { x: 610, y: 300 },
            { x: 745, y: 370 },
            { x: 800, y: 330 }
          ]
        },
        {
          speed: 1,
          step: 0.1,
          currentIndex: 0,
          currentPoint: { x: 550, y: 380 },
          points: [
            { x: 550, y: 380 },
            { x: 610, y: 410 }
          ]
        },
        {
          speed: 1.6,
          step: 0.1,
          currentIndex: 0,
          currentPoint: { x: 505, y: 405 },
          points: [
            { x: 505, y: 405 },
            { x: 580, y: 450 },
            { x: 520, y: 490 },
            { x: 710, y: 600 }
          ]
        },
        {
          speed: 1.4,
          step: 0.1,
          currentIndex: 0,
          currentPoint: { x: 420, y: 440 },
          points: [
            { x: 420, y: 440 },
            { x: 360, y: 480 },
            { x: 455, y: 538 },
            { x: 350, y: 595 },
            { x: 405, y: 635 }
          ]
        },
        {
          speed: 1.2,
          step: 0.1,
          currentIndex: 0,
          currentPoint: { x: 410, y: 430 },
          points: [
            { x: 395, y: 420 },
            { x: 245, y: 520 },
            { x: 280, y: 538 },
            { x: 180, y: 600 }
          ]
        },
        {
          speed: 1,
          step: 0.1,
          currentIndex: 0,
          currentPoint: { x: 360, y: 400 },
          points: [
            { x: 360, y: 400 },
            { x: 320, y: 430 },
            { x: 280, y: 400 },
            { x: 260, y: 415 }
          ]
        }
      ],
      loginForm: {
        username: "",
        password: "",
        rememberMe: false,
        code: "",
        uuid: ""
      },
      randomNumber: null
    });
    const formState = reactive({
      username: localStorage.getItem("username") || null,
      password: localStorage.getItem("password") || null,
      verify: "",
      remberMe: localStorage.getItem("remberMe") ? true : false
    });

    const store = useStore();

    const verifyRef = ref(null);
    const router = useRouter();

    const handleFinish = async (values) => {
      if (!formState.password || !formState.username) {
        return;
      }
      if (!formState.verify) {
        ElMessage({
          message: "验证码不能为空!",
          type: "warning"
        });
        return;
      }
      if (formState.remberMe) {
        localStorage.setItem("username", formState.username);
        localStorage.setItem("password", formState.password);
        localStorage.setItem("remberMe", formState.remberMe);
      } else {
        localStorage.removeItem("username");
        localStorage.removeItem("password");
        localStorage.removeItem("remberMe");
      }
      console.log("密码秘闻1===>", formState.password);
      console.log(
        "密码秘闻2===>",
        CryptoJS.encryptWithHMAC(formState.password)
      );
      const params = {
        passWord: CryptoJS.encryptWithHMAC(formState.password),
        serviceCode: "",
        userName: formState.username,
        code: formState.verify,
        uuid: state.qrCode.uuid
      };

      store
        .dispatch("userInfo/Login", params)
        .then(() => {
          store.dispatch("userInfo/GetInfo").then(() => {
            router.push({ path: "/entrance" });
          });
        })
        .catch(() => {
          getCodeUrl();
        });
    };

    onMounted(() => {
      const canvas = document.getElementById("systemCanvas");
      state.canvas = canvas;
      state.ctx = canvas.getContext("2d");

      animate();
      initWaves(".login-waves");
      // state.getRandomNumber()

      // document.onkeydown = (e) => {
      //   let key = window.event.keyCode;
      //   if (key == 13) {
      //     handleFinish();
      //   }
      // };
      getCodeUrl();
    });
    //点运动
    const animate = () => {
      state.ctx.clearRect(0, 0, state.canvas.width, state.canvas.height);

      // 绘制折线
      state.ctx.beginPath();
      state.dotLine.forEach((item, index) => {
        state.ctx.moveTo(item.points[0].x, item.points[0].y);
        for (let i = 1; i < item.points.length; i++) {
          state.ctx.lineTo(item.points[i].x, item.points[i].y);
        }
        state.ctx.strokeStyle = "rgba(86, 230, 255,0.5)";
        state.ctx.stroke();

        // 绘制当前点
        state.ctx.beginPath();
        state.ctx.arc(
          item.currentPoint.x,
          item.currentPoint.y,
          3,
          0,
          2 * Math.PI
        );
        state.ctx.fillStyle = "rgba(86, 230, 255,1)";
        state.ctx.fill();

        // 更新当前点的坐标
        if (item.currentIndex < item.points.length - 1) {
          var nextPoint = JSON.parse(
            JSON.stringify(item.points[item.currentIndex + 1])
          );
          var dx = nextPoint.x - item.currentPoint.x;
          var dy = nextPoint.y - item.currentPoint.y;
          var distance = Math.sqrt(dx * dx + dy * dy);
          var ratio = item.speed / distance;
          var stepX = dx * ratio;
          var stepY = dy * ratio;

          if (item.step < 1) {
            item.currentPoint.x += stepX;
            item.currentPoint.y += stepY;
            item.step += 0.01;
          } else {
            item.currentIndex++;
            item.currentPoint = JSON.parse(
              JSON.stringify(item.points[item.currentIndex])
            );
            item.step = 0;
          }
        } else {
          item.currentIndex = 0;
          item.currentPoint = JSON.parse(
            JSON.stringify(item.points[item.currentIndex])
          );
          item.step = 0;
        }
      });

      // 动画循环
      requestAnimationFrame(animate);
    };
    //获取验证码
    const getCodeUrl = () => {
      proxy.$api.getCaptchaRender().then((res) => {
        if (res.data) {
          state.qrCode = res.data;
        }
      });
    };

    return {
      ...toRefs(state),
      formState,
      formRef,
      verifyRef,
      handleFinish,
      getCodeUrl
    };
  }
});
</script>

<style lang="less" scoped>
.login-container {
  height: 100%;
  width: 100%;
  overflow: hidden;
  // background-image: url("../../assets/images/login-container.png");
  background-color: rgba(2, 9, 36, 1);
  position: relative;
  .login-waves {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 200px;
  }
  .login-panel {
    position: absolute;
    width: 417px;
    height: 640px;
    bottom: 20.37%;
    right: 11.4%;
    background-image: url("../../assets/images/login-panel.png");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    .login-form {
      position: absolute;
      width: 256px;
      top: 120px;
      left: 84px;
      .login-title {
        font-size: 24px;
        font-weight: 700;
        line-height: 34px;
        letter-spacing: 0px;
        text-align: center;
        color: white;
        margin-bottom: 12px;
      }
      .login-title-en {
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: Alibaba PuHuiTi 2;
        font-size: 10px;
        font-weight: 400;
        line-height: 14px;
        letter-spacing: 0px;
        text-align: center;
        color: rgba(180, 246, 255, 1);
        margin-bottom: 47px;
        span {
          margin: 0 2px;
        }
      }
      .login-component {
        width: 100%;
        height: 42px;
        border: 1px solid rgba(58, 221, 229, 1);
        border-radius: 24px;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        img {
          margin-left: 20px;
        }
        .login-input {
          background: transparent !important;
          .el-input__inner {
            background: transparent !important;
            border: none !important;
          }
        }
      }
      .login-submit {
        background-color: rgba(0, 204, 215, 1);
        color: white;
        font-family: Alibaba PuHuiTi 2;
        font-size: 16px;
        font-weight: 700;
        line-height: 44px;
        letter-spacing: 0px;
        text-align: center;
        height: 44px;
        cursor: pointer;
        margin-top: 60px;
        border-radius: 24px;
      }
    }
  }
  .login-left {
    position: absolute;
    width: 911px;
    height: 735px;
    bottom: 16.95%;
    left: 6.35%;
    background-image: url("../../assets/images/canvas_bg.png");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;

    section {
      position: absolute;
      top: 240px;
      left: 350px;
      width: 175px;
      height: 120px;
      background-position-x: center;
      background-size: cover;
      // background: linear-gradient(
      //   to bottom,
      //   rgba(86, 230, 255, 0) 0%,
      //   rgba(86, 230, 255, 0.3) 100%
      // );
      background: transparent;
    }

    span {
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 3px;
      height: 20px;
      background: linear-gradient(
        to bottom,
        rgba(69, 94, 240, 0.2) 0%,
        rgba(86, 230, 255, 0.5) 50%,
        rgba(9, 94, 240, 0.2) 100%
      );
      border-radius: 50%;
      /* box-shadow: 0 0 0 4px  
      rgba(255,255,255,0.1),0 0 0 8px 
      rgba(255,255,255,0.1),0 0 20px 
       rgba(255,255,255,1);  */
      opacity: 0;
      animation: animate 5s linear infinite;
    }
    @keyframes animate {
      0% {
        transform: translateY(80px);
        opacity: 0;
      }
      50% {
        opacity: 1;
      }
      100% {
        transform: translateY(0px);
        opacity: 0;
      }
    }
    /* span::before{
      content: '';
      position: absolute;
      top:50%;
      transform: translateX(-50%);
      width: 200px;
      height: 1px;
      background: linear-gradient(90deg,#fff,transparent);
    } */
    span:nth-child(1) {
      top: 0;
      right: 0;
      left: initial;
      animation-delay: 0;
      animation-duration: 1s;
    }
    span:nth-child(2) {
      top: 0;
      right: 15px;
      left: initial;
      animation-delay: 0.2s;
      animation-duration: 1s;
    }
    span:nth-child(3) {
      top: 0px;
      right: 30px;
      left: initial;
      animation-delay: 0.4s;
      animation-duration: 2s;
    }
    span:nth-child(4) {
      top: 0;
      right: 45px;
      left: initial;
      animation-delay: 0.6s;
      animation-duration: 1.5s;
    }
    span:nth-child(5) {
      top: 0;
      right: 60px;
      left: initial;
      animation-delay: 0.8s;
      animation-duration: 2.5s;
    }
    span:nth-child(6) {
      top: 0;
      right: 75px;
      left: initial;
      animation-delay: 1s;
      animation-duration: 3s;
    }
    span:nth-child(7) {
      top: 0;
      right: 90px;
      left: initial;
      animation-delay: 1.2s;
      animation-duration: 1.75s;
    }
    span:nth-child(8) {
      top: 0;
      right: 105px;
      left: initial;
      animation-delay: 1.4s;
      animation-duration: 1.25s;
    }
    span:nth-child(9) {
      top: 0;
      right: 120px;
      left: initial;
      animation-delay: 1.6s;
      animation-duration: 1s;
    }
    span:nth-child(10) {
      top: 0;
      left: 0px;
      animation-delay: 2.2s;
      animation-duration: 1.54s;
    }
    span:nth-child(11) {
      top: 0;
      left: 15px;
      animation-delay: 2s;
      animation-duration: 2s;
    }
    span:nth-child(12) {
      top: 0;
      left: 30px;
      animation-delay: 2.1s;
      animation-duration: 1.8s;
    }
    span:nth-child(13) {
      top: 0;
      left: 45px;
      animation-delay: 1.9s;
      animation-duration: 1.3s;
    }
    span:nth-child(14) {
      top: 0;
      left: 60px;
      animation-delay: 2.3s;
      animation-duration: 2.1s;
    }
    span:nth-child(15) {
      top: 0;
      left: 75px;
      animation-delay: 2.2s;
      animation-duration: 1.9s;
    }
  }
  .login-copyright {
    position: fixed;
    bottom: 10px;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 12px;
    color: rgba(255, 255, 255, 0.6);
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 40px;
      height: 20px;
    }
  }
}
</style>
<style lang="less">
.login-input {
  background: transparent !important;
  padding-right: 10px;
  .el-input__wrapper {
    background: transparent !important;
    border: none !important;
    color: white !important;
    box-shadow: none;
  }
  .el-input__inner {
    background: transparent !important;
    border: none !important;
    color: white !important;
    &:-webkit-autofill,
    textarea:-webkit-autofill,
    select:-webkit-autofill {
      -webkit-text-fill-color: #fff !important;
      box-shadow: white !important;
      -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
      background-color: transparent !important;
      color: #fff !important;
      background-image: none;
      transition: background-color 50000s ease-in-out 0s;
      border: none;
    }
  }
  .el-input-group__append {
    color: white;
    border: none;
    background: transparent;
    box-shadow: none;
    // border-radius: 24px;
    // font-size: 14px;
    // letter-spacing: 0.2em;
    width: 100px;
    img {
      height: 100%;
      width: 60px;
      margin: 0 !important;
    }
  }
}
</style>
